/* unplugin-vue-components disabled */
import BuilderInputs from 'components/builder/builder-inputs.vue'

import AgentOutput from './agent-output.vue'
import {makeTestAgentSchema, MAX_TEST_AGENTS} from './test-agents-defs'

const emptyAgent = () => ({
  name: '',
  description: '',
  prompt: '',
  pass_sources: false,
  tools: [],
  output: {}
})

export default {
  components: {BuilderInputs, AgentOutput},
  props: {
    agents: {type: Array, required: true},
    tools: {type: Array, default: () => []}
  },
  emits: ['add', 'save', 'update:editing_idx'],
  data() {
    return {
      fields: emptyAgent(),
      prev_snapshot: undefined,
      editing_idx: undefined,
      valid: true
    }
  },
  computed: {
    schema() {
      return makeTestAgentSchema(this.validateName, this.tools)
    },
    has_diff() {
      return !$utils.object.same(this.fields, this.prev_snapshot || emptyAgent())
    },
    can_save() {
      return this.valid && this.has_diff &&
        (this.editing_idx !== undefined || this.agents.length < MAX_TEST_AGENTS)
    }
  },
  methods: {
    validateName(name) {
      return this.agents.some((agent, idx) => idx !== this.editing_idx && agent.name === name)
        ? 'An agent with this name already exists.'
        : true
    },
    edit(agent, index) {
      this.editing_idx = index
      this.fields = {...emptyAgent(), ...agent}
      this.prev_snapshot = $utils.object.deepCopy(this.fields)
    },
    discard() {
      this.fields = emptyAgent()
      this.prev_snapshot = undefined
      this.editing_idx = undefined
    },
    onAgentDeleted(index) {
      if (this.editing_idx === index) {
        this.discard()
      }
    },
    submit() {
      if (!this.can_save) return
      if (this.editing_idx === undefined) this.$emit('add', this.fields)
      else this.$emit('save', this.editing_idx, this.fields)
      this.discard()
    }
  }
}
